export const homePageUrl = "/"
// export const homePageUrl = "/projects/glyphertech";
// export const homePageUrl = "/clients/glyphertech";

// http://localhost:3000/auditor/company/getCompany

// http://localhost:3000/auditor/compliancer/register
// export const directUrl = 'https://bsbgroup.glyphrtech.com/'
export const directUrl = '/'
